import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'src/components/layouts/Modal/Modal';
import Button, { ButtonToneProps } from 'src/components/ui/Button/Button';
import Checkbox from 'src/components/ui/Checkbox/Checkbox';

// Inbound-Draft spec 2026-11-03 §6: the terms stay a local checkbox (status quo of
// the old wizard summary), now asked right before the confirm call.
const InboundConfirmDialog: React.FC<{ isOpen: boolean; onClose: (confirmed: boolean) => void; isBusy?: boolean }> = ({
  isOpen,
  onClose,
  isBusy,
}) => {
  const { t } = useTranslation();
  const [termsAccepted, setTermsAccepted] = useState(false);

  useEffect(() => {
    if (!isOpen) setTermsAccepted(false);
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={() => onClose(false)}>
      <div className="max-w-[480px] w-full">
        <div className="border-subtle-bottom p-32 flex flex-col gap-y-12 mt-16">
          <h4 className="typo-title-24">{t('inbound.confirm_dialog_title')}</h4>
          <p className="typo-text-16 text-faded">{t('inbound.confirm_dialog_copy')}</p>
          <div className="flex gap-12 typo-text-14--medium items-center">
            <Checkbox checked={termsAccepted} onChange={e => setTermsAccepted(e.target.checked)} />
            {t('general.weship_terms')}
          </div>
        </div>
        <div className="border-subtle-bottom py-16 px-24 flex justify-end">
          <Button
            className="mr-12 !rounded-[8px]"
            onClick={() => onClose(false)}
            tone={ButtonToneProps.SECONDARY}
            title={t('general.cancel')}
          />
          <Button
            className="!rounded-[8px]"
            onClick={() => onClose(true)}
            tone={ButtonToneProps.PRIMARY_BLUE}
            title={t('inbound.confirm_cta')}
            disabled={!termsAccepted || isBusy}
          />
        </div>
      </div>
    </Modal>
  );
};

export default InboundConfirmDialog;
